// Generated at build — used to bust stale PWA caches
export const BUILD_ID = '729fb82f19e516f91b34aace19491a41fee63793';
